/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsinvoicetitle2Inputs */

const en_ticketsinvoicetitle2 = /** @type {(inputs: Ticketsinvoicetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoices to buyers`)
};

const de_ticketsinvoicetitle2 = /** @type {(inputs: Ticketsinvoicetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechnungen an Käufer`)
};

/**
* | output |
* | --- |
* | "Invoices to buyers" |
*
* @param {Ticketsinvoicetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsinvoicetitle2 = /** @type {((inputs?: Ticketsinvoicetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsinvoicetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsinvoicetitle2(inputs)
	return de_ticketsinvoicetitle2(inputs)
});
export { ticketsinvoicetitle2 as "ticketsInvoiceTitle" }